import { AlertCircle, CircleDot, Crown, PauseCircle, RefreshCw } from "lucide-react";
import type { Site } from "@baze/api-client";
import { Badge } from "@/components/ui/badge";
import { daysUntil, formatDate } from "@/lib/format";
import { t } from "@/i18n/id";

export function SiteStatusChips({ site, showPlan = true }: { site: Site; showPlan?: boolean }) {
  const expired = site.plan.expiresAt ? daysUntil(site.plan.expiresAt) < 0 : false;
  return (
    <div className="flex flex-wrap gap-1.5">
      {site.status === "suspended" ? (
        <Badge tone="danger">
          <PauseCircle aria-hidden="true" />
          {t.sites.status.suspended}
        </Badge>
      ) : site.status === "published" ? (
        <Badge tone="success" dot>
          {t.sites.status.published}
        </Badge>
      ) : (
        <Badge tone="neutral">
          <CircleDot aria-hidden="true" />
          {t.sites.status.draft}
        </Badge>
      )}
      {site.status === "published" && site.hasUnpublishedChanges ? (
        <Badge tone="warning">
          <RefreshCw aria-hidden="true" />
          {t.sites.status.unpublished}
        </Badge>
      ) : null}
      {showPlan && site.plan.limits.customDomain ? (
        <Badge tone="brand">
          <Crown aria-hidden="true" />
          {site.plan.planName}
        </Badge>
      ) : null}
      {expired ? (
        <Badge tone="danger">
          <AlertCircle aria-hidden="true" />
          {t.sites.expired}
        </Badge>
      ) : site.plan.renewalDue && site.plan.expiresAt ? (
        <Badge tone="warning">
          <AlertCircle aria-hidden="true" />
          {t.sites.renewalDue(formatDate(site.plan.expiresAt))}
        </Badge>
      ) : null}
    </div>
  );
}

export const displayUrl = (url: string) => url.replace(/^https?:\/\//, "").replace(/\/$/, "");
